import useFlag from "~/hooks/useFlag";
import { TOTAL_VALUE } from "~/constants/flags";

/**
 * Single source of truth for the TOTAL_VALUE feature flag.
 *
 * Any UI that belongs to the Total Value feature flag (e.g. the Total Value badge and its
 * drawer) should gate its rendering through this hook so the flag is read from one
 * place. When the flag is off, consumers must render nothing to avoid leaking
 * hidden / unfinished content into the DOM.
 */
export const useTotalValue = (): boolean => {
    return Boolean(useFlag(TOTAL_VALUE));
};

export default useTotalValue;
